import script from "./TagsElement.vue?vue&type=script&lang=js"
export * from "./TagsElement.vue?vue&type=script&lang=js"

import "./TagsElement.vue?vue&type=style&index=0&id=c5c11100&lang=scss"

const __exports__ = script;

export default __exports__